import { Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  serviceDialogRef = new BehaviorSubject<any>(null)
  serviceDialogRef$ = this.serviceDialogRef.asObservable()

  constructor(private dialog: MatDialog) {}

  open(component, data?, autoFocus = false) {
    const dialogRef = this.dialog.open(component, {
      panelClass: 'phx-dialog-container',
      autoFocus: autoFocus,
      data: data,
    })

    this.serviceDialogRef.next(dialogRef)
    return dialogRef
  }
}
